"use client";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { handleParse } from "@/lib/handleParse";
import { truncateText } from "@/lib/utils";

interface TruncatedTextProps {
  text: string;
  maxLength?: number;
  title?: string;
}

export function TruncatedText({
  text,
  maxLength = 20,
  title,
}: TruncatedTextProps) {
  const { displayText, fullText, isTruncated } = truncateText(text, maxLength);

  if (!isTruncated) {
    return <span>{displayText}</span>;
  }

  return (
    <AlertDialog>
      <div className="">
        {handleParse(displayText.slice(0, -5))}
        <AlertDialogTrigger className="text-primary  hover:text-primary-foreground cursor-pointer">
          [...]
          <span className="sr-only">Läs mer om {title}</span>
        </AlertDialogTrigger>
      </div>

      <AlertDialogContent className="max-w-lg max-h-[80vh] overflow-auto">
        <AlertDialogHeader>
          <AlertDialogTitle className="sr-only">Full Text</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="mt-4">{handleParse(fullText)}</div>
        <AlertDialogFooter>
          <AlertDialogAction>Stäng</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
